import React from 'react';
import {
    AppBar,
    Box,
    Container,
    Toolbar,
    Typography,
    IconButton,
    Button,
    Menu,
    MenuItem,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import Title from './Title';
import ToggleColorButton from './ToggleColorButton';

const menu = [{ label: 'Scan', route: '/scan' }];

const ResponsiveAppBar = ({ appName, colorMode }) => {
    const navigate = useNavigate();
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    return (
        <AppBar position={'sticky'} elevation={3}>
            <Container maxWidth={'xl'}>
                <Toolbar disableGutters>
                    {/* Affichage Mobile */}
                    <Box
                        sx={{
                            flexGrow: 1,
                            display: { xs: 'flex', md: 'none' },
                        }}
                    >
                        <IconButton
                            size='large'
                            edge='start'
                            color='inherit'
                            aria-label='menu'
                            aria-controls='menu-appbar'
                            aria-haspopup='true'
                            onClick={handleOpenNavMenu}
                            sx={{ mr: 2 }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id='menu-appbar'
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {menu.map(({ label, route }, index) => (
                                <MenuItem
                                    key={index}
                                    onClick={() => navigate(route)}
                                >
                                    <Typography textAlign='center'>
                                        {label}
                                    </Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <Button onClick={() => navigate('/')}>
                        <Title
                            appName={appName}
                            display={{ xs: 'flex', md: 'none' }}
                            mobile={true}
                        />
                    </Button>

                    {/* Affichage  Desktop */}
                    <Button onClick={() => navigate('/')}>
                        <Title
                            appName={appName}
                            display={{ xs: 'none', md: 'flex' }}
                        />
                    </Button>
                    <Box
                        sx={{
                            flexGrow: 1,
                            display: { xs: 'none', md: 'flex' },
                        }}
                    >
                        {menu.map(({ label, route }, index) => (
                            <Button
                                key={index}
                                sx={{
                                    my: 2,
                                    color: 'white',
                                    display: 'block',
                                }}
                                onClick={() => navigate(route)}
                            >
                                {label}
                            </Button>
                        ))}
                    </Box>

                    {/* Affichage toutes tailles  */}
                    <Box
                        sx={{
                            flexGrow: 0,
                        }}
                    >
                        <ToggleColorButton colorMode={colorMode} />
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default ResponsiveAppBar;
